import { ComputedRoute, ElevationsChart, Route, useUnits } from '@geovelo-frontends/commons';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

function ElevationProfile({
  size,
  route,
}: {
  route: ComputedRoute | Route | null | undefined;
  size?: 'small';
}): JSX.Element {
  const { t } = useTranslation();
  const { toDistance } = useUnits();

  if (route === null) return <></>;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box alignItems="center" display="flex" gap={2}>
        <Typography
          component="h2"
          fontWeight={size === 'small' ? 600 : 700}
          variant={size === 'small' ? 'body1' : 'h6'}
        >
          {t('geovelo.rides.detail.elevation_profile')}
        </Typography>
        <Box flexGrow={1} />
        <Box alignItems="center" display="flex" gap={1}>
          <ArrowUpward fontSize="small" sx={{ color: '#cd3244' }} />
          <Typography variant={size === 'small' ? 'caption' : 'body1'}>
            {route ? toDistance(route.verticalGain) : <Skeleton variant="text" width={50} />}
          </Typography>
        </Box>
        <Box alignItems="center" display="flex" gap={1}>
          <ArrowDownward fontSize="small" sx={{ color: '#2ac682' }} />
          <Typography variant={size === 'small' ? 'caption' : 'body1'}>
            {route ? toDistance(route.verticalLoss) : <Skeleton variant="text" width={50} />}
          </Typography>
        </Box>
      </Box>
      <Box height={150}>
        <ElevationsChart route={route} />
      </Box>
    </Box>
  );
}

export default ElevationProfile;
